"use client";
import { useRef as u, useEffect as t } from "react";
function o(r) {
  const e = u();
  return t(() => (e.current = r, () => {
    e.current = void 0;
  })), e.current;
}
export {
  o as default
};
